"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RTLLanguages = ["ar"];
var I8N = (function () {
    function I8N() {
    }
    I8N.locale = function () {
        return this.current;
    };
    I8N.setLocale = function (locale) {
        this.current = locale;
    };
    I8N.isRTL = function () {
        var _this = this;
        return exports.RTLLanguages.find(function (x) { return x === _this.current; }) != undefined;
    };
    I8N.current = "en";
    return I8N;
}());
exports.I8N = I8N;
exports.default = I8N;
//# sourceMappingURL=I8N.js.map